import * as z from 'zod';
import { currencySchema } from '../utils.mjs';
import { formulaSchema } from './formula.mjs';

var AdjustableValuesUpdate;
(function (AdjustableValuesUpdate) {
    AdjustableValuesUpdate.schema = z
        .object({
        value: currencySchema.nullish(),
        formula: formulaSchema.nullish(),
        note: z.string().optional(),
    })
        .refine((data) => data.value !== undefined || data.formula !== undefined, {
        message: "At least one of value or formula must be provided",
    });
})(AdjustableValuesUpdate || (AdjustableValuesUpdate = {}));

export { AdjustableValuesUpdate };
